import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_88994016: FaireBrandEntity = {
  token: "b_88994016",
  type: "brand",
  name: "Gotamago",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c4370e203647c40aba1b1e86a7a21302ee206bcbf29c7b63f3aaf82334ea6cb9/1557338798.jpg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/989ef0dd2c1f3f4f227e2ebdee471779d9cd701359242ff98247475a26134274/1557362755.jpg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c4370e203647c40aba1b1e86a7a21302ee206bcbf29c7b63f3aaf82334ea6cb9/1557338798.jpg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/989ef0dd2c1f3f4f227e2ebdee471779d9cd701359242ff98247475a26134274/1557362755.jpg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 130,
  rating: 5,
  reviewCount: 17,
  isInsider: false,
  description:
    'Gotamago is a tiny-but-mighty design studio based in Toronto, Canada, founded in 2013 by wife-and-husband team Lichia and Christopher. Combining their love for urbanity, travel-sketching, word-smithing, and storytelling, the duo delights in creating beautiful, fun and one-of-a-kind stationery and gift products.\n\nGotamago values ethical manufacturing, sustainable production and local partnerships. Most of our products are made in Canada, with a focus on plastic-free packaging starting from the design phase. \n\nThe name "Gotamago" is derived from the Japanese word for "egg" (tamago), which is also used in Taiwanese, Lichia\'s native dialect.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:08.844Z",
    importedBy: "entity-db-cli",
  },
};
